import { createGlobalStyle, css } from 'styled-components';
import dark from './themes/dark';
import * as t from './tokens';
import { themeable } from 'themes/utils';
import {
    mobileMediaQuery,
    onlyTabletMediaQuery,
    notDesktopMediaQuery
} from 'utils/mediaQuery';
import { blockName, blockNameIOS } from 'utils/scroll';

export const GlobalStyle = createGlobalStyle`
    ${dark}

    :root {
        ${t.headlineSizeL.name}: 24px;
        ${t.headlineSizeXl.name}: 36px;
        ${t.containerMaxWidth.name}: 1792px;
        ${t.textMSize.name}: 16px;
        ${t.textXSSize.name}: 12px;
        ${t.textMBigSize.name}: 18px;
        ${t.headingHeight.name}: 60px;

        ${notDesktopMediaQuery(css`
            ${t.headlineSizeXl.name}: 24px;
        `)}

        ${onlyTabletMediaQuery(css`
            ${t.headlineSizeL.name}: 20px;
        `)}

        ${mobileMediaQuery(css`
            ${t.headlineSizeL.name}: 16px;
            ${t.textMSize.name}: 14px;
            ${t.textXSSize.name}: 10px;
            ${t.textMBigSize.name}: 16px;
        `)}
    }

    html, body {
        color: ${themeable('textColor')};
        background: ${themeable('bodyBackgroundColor')};

        ${notDesktopMediaQuery(css`
            background-color: ${themeable('mainBackgroundColor')};
        `)}
    }
        /* Стилизация полосы прокрутки */
    ::-webkit-scrollbar {
        width: 12px; /* Ширина полосы прокрутки */

        ${onlyTabletMediaQuery(css`
            width: 6px;
        `)}

        ${mobileMediaQuery(css`
            width: 3px;
        `)} 
    }

    ::-webkit-scrollbar-track {
        background: ${themeable(
            'scrollbarTrackColor'
        )}; /* Цвет фона полосы прокрутки */
    }

    ::-webkit-scrollbar-thumb {
        background-color: ${themeable(
            'scrollbarThumbColor'
        )}; /* Цвет бегунка полосы прокрутки */
        border-radius: 10px;
        border: 3px solid ${themeable('scrollbarTrackColor')}
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: ${themeable(
            'scrollbarThumbHoverColor'
        )}; /* Цвет бегунка при наведении */
    }

    .${blockName} {
        overscroll-behavior: none;
        overflow: hidden;
    }

    .${blockNameIOS}{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
    }

`;
